import axios from '@api'

export default {
    getBuyer () {
      return axios.get(`api/management/buyer`);
    },
    deleteBuyer (buyerId) {
      return axios.put(`api/management/buyer/delete/${buyerId}`);
    },
    saveBuyer (json) {
      return axios.post(`api/management/buyer/save`, json);
    }
}